module.exports = __webpack_public_path__ + "static/img/qianyue2.1b8a84e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/qianyue2.png
// module id = sWp5
// module chunks = 1